import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Trans } from 'react-i18next';

import { QUERY_KEYS } from '@hero/constants';
import { organizationServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';

export const useUpdateOrganizationUser = options => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();

  return useMutation(
    ({ userCode, body }) => organizationServices.updateOrganizationUser(userCode, body),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEYS.useGetOrganizationUserKey);

        showSuccess({
          message: <Trans i18nKey="changesSuccessfullySaved" components={{ b: <b /> }} />,
          type: 'toast'
        });
      },
      ...options
    }
  );
};
